/* eslint-disable */
import api from "@/api";
import router from "@/router";
import {defineStore} from "pinia/dist/pinia";
import {useUserStore} from "@/stores/user";
import packageJson from "../../package.json";
import {client} from '@/stores/client.js'

export const useOrdersStore = defineStore('orders', {
    state: () => ({
        accountOrders: [],
        boostOrders: [],
        currencyBuyOrders: [],
        currencySellOrders: [],
        accountOrderApplicants: [],
        boostOrderApplicants: [],
        currencyBuyOrderApplicants: [],
        currencySellOrderApplicants: [],
        selectedOrder: {}
    }),
    getters: {
        getAccountOrders(state) {
            return state.accountOrders;
        },
        getBoostOrders(state) {
            return state.boostOrders;
        },
        getCurrencyBuyOrders(state) {
            return state.currencyBuyOrders;
        },
        getCurrencySellOrders(state) {
            return state.currencySellOrders;
        },
        getBoostOrderApplicants(state) {
            return state.boostOrderApplicants;
        },
        getAccountOrderApplicants(state) {
            return state.accountOrderApplicants;
        },
        getCurrencySellOrderApplicants(state) {
            return state.currencySellOrderApplicants;
        },
        getCurrencyBuyOrderApplicants(state) {
            return state.currencyBuyOrderApplicants;
        },
        get_selected_order(state) {
            return state.selectedOrder
        },
        get_delivered_orders: () => orders => {
            return orders.filter(order => order.state === "Delivered");
        },
        get_delivering_orders: () => orders => {
            return orders.filter(order => order.state === "Delivering");
        },
        get_canceled_orders: () => orders => {
            return orders.filter(order => order.state === "Canceled");
        },
        get_all_orders_filter_delivering: () => orders => {
            return orders.filter(order => order.state !== "Delivering");
        }
    },
    actions: {
        async action_get_account_active_hot_orders() {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10107,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                //console.log('action_get_account_active_hot_orders', data)
                if (data.response === 100) {
                    console.log(data)
                    this.accountOrders = data.accountOrders;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_getAccountActiveHotOrder() {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10108,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
        },
        async action_addAccountHotOrderApplicant(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10115,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "accountOrder": {
                    "id": payload.id
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_addAccountHotOrderApplicant', data)
                if (data.response === 100) {
                    return true;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_removeAccountHotOrderApplicant(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10116,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "accountOrder": {
                    "id": payload.id
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_removeAccountHotOrderApplicant', data)
                if (data.response === 100) {
                    return true;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },

        async action_getBoostActiveHotOrders() {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10109,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_getBoostActiveHotOrders', data)
                if (data.response === 100) {
                    this.boostOrders = data.boostOrders;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_get_boost_active_hot_order(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10110,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "boostOrder": {
                    "id": payload.id
                },
                "client": client
            };
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_get_boost_active_hot_order', data)
                if (data.response === 100) {
                    console.log("response 100")
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_addBoostHotOrderApplicant(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10117,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "boostOrder": {
                    "id": payload.id
                },
                "client": client
            };
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_addBoostHotOrderApplicant', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_removeBoostHotOrderApplicant(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10118,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "boostOrder": {
                    "id": payload.id
                },
                "client": client
            };
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_removeBoostHotOrderApplicant', data)
                if (data.response === 100) {
                    return true;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },

        async action_getCurrencyBuyActiveHotOrders() {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10111,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_getCurrencyBuyActiveHotOrders', data)
                if (data.response === 100) {
                    this.currencyBuyOrders = data.currencyBuyOrders;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_getCurrencyBuyActiveHotOrder() {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10112,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
        },
        async action_addCurrencyBuyHotOrderApplicant(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10119,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencyBuyOrder": {
                    "id": payload.id
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_addCurrencyBuyHotOrderApplicant', data)
                if (data.response === 100) {
                    return true;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_removeCurrencyBuyHotOrderApplicant(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10120,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencyBuyOrder": {
                    "id": payload.id
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_removeCurrencyBuyHotOrderApplicant', data)
                if (data.response === 100) {
                    return true;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },

        async action_getCurrencySellActiveHotOrders() {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10113,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_getCurrencySellActiveHotOrders', data)
                if (data.response === 100) {
                    this.currencySellOrders = data.currencySellOrders;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_getCurrencySellActiveHotOrder() {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10114,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
        },
        async action_addCurrencySellHotOrderApplicant(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10121,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencySellOrder": {
                    "id": payload.id
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_addCurrencySellHotOrderApplicant', data)
                if (data.response === 100) {
                    return true;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_removeCurrencySellHotOrderApplicant(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10122,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencySellOrder": {
                    "id": payload.id
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_removeCurrencySellHotOrderApplicant', data)
                if (data.response === 100) {
                    return true;
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },

        async action_getAccountHotOrderApplicants(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10123,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "accountOrder": {
                    "id": payload.id
                },
                "client": client
            };
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_getAccountHotOrderApplicants', data)
                if (data.response === 100) {
                    this.accountOrderApplicants = data.accountOrder.applicants;
                    this.accountOrderApplicants.forEach(user => {
                        user.fullName = `${user.firstName} ${user.lastName}`;
                    });
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_getBoostHotOrderApplicants(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10124,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "boostOrder": {
                    "id": payload.id
                },
                "client": client
            };
            //console.log("request:", request)
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_getBoostHotOrderApplicants', data)
                if (data.response === 100) {
                    this.boostOrderApplicants = data.boostOrder.applicants;
                    this.boostOrderApplicants.forEach(user => {
                        user.fullName = `${user.firstName} ${user.lastName}`;
                    });
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_getCurrencyBuyHotOrderApplicants(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10125,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencyBuyOrder": {
                    "id": payload.id
                },
                "client": client
            };
            console.log("request :", request)
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_getCurrencyBuyHotOrderApplicants', data)
                if (data.response === 100) {
                    this.currencyBuyOrderApplicants = data.currencyBuyOrder.applicants;
                    this.currencyBuyOrderApplicants.forEach(user => {
                        user.fullName = `${user.firstName} ${user.lastName}`;
                    });
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_getCurrencySellHotOrderApplicants(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10126,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencySellOrder": {
                    "id": payload.id
                },
                "client": client
            };
            console.log("request: ", request)
            await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_getCurrencySellHotOrderApplicants', data)
                if (data.response === 100) {
                    this.currencySellOrderApplicants = data.currencySellOrder.applicants;
                    this.currencySellOrderApplicants.forEach(user => {
                        user.fullName = `${user.firstName} ${user.lastName}`;
                    });
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },

        async action_get_taker_account_orders(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10127,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            if (!payload.currentUser) {
                request.profile = {
                    "id": payload.takerID
                }
            }
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_get_taker_account_orders', data)
                if (data.response === 100) {
                    return data.accountOrders
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_get_taker_boost_orders(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10128,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            if (!payload.currentUser) {
                request.profile = {
                    "id": payload.takerID
                }
            }
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_get_taker_boost_orders', data)
                if (data.response === 100) {
                    return data.boostOrders
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_get_taker_currency_buy_orders(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10129,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            if (!payload.currentUser) {
                request.profile = {
                    "id": payload.takerID
                }
            }
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_get_taker_currency_buy_orders', data)
                if (data.response === 100) {
                    return data.currencyBuyOrders
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_get_taker_currency_sell_orders(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10130,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "client": client
            };
            if (!payload.currentUser) {
                request.profile = {
                    "id": payload.takerID
                }
            }
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_get_taker_currency_sell_orders', data)
                if (data.response === 100) {
                    return data.currencySellOrders
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },

        async action_set_account_order_taker(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10131,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "accountOrder": {
                    "id": payload.id,
                    "takerID": payload.takerID,
                    "notes": payload.notes
                },
                "client": client
            };
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_set_account_order_taker', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_set_boost_order_taker(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10132,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "boostOrder": {
                    "id": payload.id,
                    "takerID": payload.takerID,
                    "notes": payload.notes
                },
                "client": client
            };
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_set_boost_order_taker', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_set_currency_buy_order_taker(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10133,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencyBuyOrder": {
                    "id": payload.id,
                    "takerID": payload.takerID,
                    "notes": payload.notes
                },
                "client": client
            };
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_set_currency_buy_order_taker', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_set_currency_sell_order_taker(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10134,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencySellOrder": {
                    "id": payload.id,
                    "takerID": payload.takerID,
                    "notes": payload.notes
                },
                "client": client
            };
            //console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_set_currency_sell_order_taker', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },

        async action_update_account_hot_order(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10090,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "accountOrder": {
                    "id": payload.id,
                    "title": payload.title,
                    "description": payload.description,
                    "price": payload.price,
                    "takerID": payload.takerID,
                    "state": payload.state,
                    "notes": payload.notes,
                    "attachments": payload.attachments,
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_update_account_hot_order', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_update_boost_hot_order(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10095,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "boostOrder": {
                    "id": payload.id,
                    "state": payload.state,
                    "notes": payload.notes,
                    "attachments": {
                        "paymentReceipts": payload.attachments
                    },
                },
                "client": client
            };
            console.log(request)
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_update_boost_hot_order', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_update_currency_buy_hot_order(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10100,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencyBuyOrder": {
                    "id": payload.id,
                    "title": payload.title,
                    "description": payload.description,
                    "price": payload.price,
                    "takerID": payload.takerID,
                    "state": payload.state,
                    "notes": payload.notes,
                    "attachments": payload.attachments,
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_update_currency_buy_hot_order', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },
        async action_update_currency_sell_hot_order(payload) {
            const userStore = useUserStore()
            const request = {
                "request": 1009,
                "subRequest": 10105,
                "account": {
                    "id": userStore.getUserId,
                    "credential": userStore.getCredential
                },
                "currencySellOrder": {
                    "id": payload.id,
                    "state": payload.state,
                    "notes": payload.notes,
                    "attachments": {
                        "paymentReceipts": payload.attachments
                    },
                },
                "client": client
            };
            return await api.post('', request).then((res) => {
                if (res.status === 200) {
                    return res.data
                } else {
                    console.log('response is ' + res.status)
                }
            }).then((data) => {
                console.log('action_update_currency_sell_hot_order', data)
                if (data.response === 100) {
                    return true
                } else if (data.response === -100002) {
                    userStore.resetUser('your credential is expired');
                    router.push({name: 'Login'})
                } else {
                    userStore.errorMessage = data.message
                    return false
                }
            })
        },

        set_selected_order(payload) {
            this.selectedOrder = payload
        }
    },
})
